var map = {
	"./ilustra_frente_cin.png": "Zs+l",
	"./ilustra_frente_cnh.png": "cRcK",
	"./ilustra_frente_outro_doc.png": "aZb3",
	"./ilustra_frente_rg.png": "DWpY",
	"./ilustra_lampada.png": "BDcm",
	"./ilustra_moldura.png": "TiAa",
	"./ilustra_protecaodoc.png": "TlU+",
	"./ilustra_verso_cin.png": "IuZw",
	"./ilustra_verso_cnh.png": "dVjB",
	"./ilustra_verso_outro_doc.png": "S09I",
	"./ilustra_verso_rg.png": "XhLY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hMmb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc nonrecursive \.png$
// module id = hMmb
// module chunks = 1